// Analytics Events Configuration
// This file contains standardized event definitions for tracking user interactions

export const ANALYTICS_CATEGORIES = {
  USER: 'User',
  PROPERTY: 'Property',
  PROFILE: 'Profile',
  NAVIGATION: 'Navigation',
  INTERACTION: 'Interaction',
  LOGIN: 'Login',
  MESSAGING: 'Messaging',
  SEARCH: 'Search',
  FILTER: 'Filter',
  UPLOAD: 'Upload',
  VERIFICATION: 'Verification',
  ORGANIZATION: 'Organization',
  NOTIFICATION: 'Notification',
  PAYMENT: 'Payment',
  RECOMMENDATION: 'Recommendation',
  BOOST: 'Boost',
  MATERIALS: 'Materials',
  BACK: 'Back',
  SAVE: 'Save',
  AGENT: 'Agent',
  LANGUAGE: 'Language',
  FEEDBACK: 'Feedback',
  AIRA: 'Aira',
  PROCEED: 'Proceed',
  I_AM_NOT_AN_AGENT: 'I am not an Agent',
};

export const ANALYTICS_ACTIONS = {
  // User Actions
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  SIGNUP: 'Signup',
  REGISTER: 'Register',
  PROFILE_VIEW: 'Profile View',
  PROFILE_EDIT: 'Profile Edit',
  PROFILE_UPDATE: 'Profile Update',
  PROFILE_DELETE: 'Profile Delete',
  SETTINGS_UPDATE: 'Settings Update',
  PREFERENCES_UPDATE: 'Preferences Update',
  LANGUAGE_CHANGE: 'Language Change',

  // Property Actions
  ADD_PROPERTY: 'Add Property',
  EDIT_PROPERTY: 'Edit Property',
  DELETE_PROPERTY: 'Delete Property',
  VIEW_PROPERTY: 'View Property',
  SAVE_PROPERTY: 'Save Property',
  UNSAVE_PROPERTY: 'Unsave Property',
  SHARE_PROPERTY: 'Share Property',
  PUBLISH_PROPERTY: 'Publish Property',
  DRAFT_PROPERTY: 'Draft Property',
  VERIFY_PROPERTY: 'Verify Property',
  BOOST_PROPERTY: 'Boost Property',
  GENERATE_DESCRIPTION: 'Generate Description',
  UPLOAD_IMAGES: 'Upload Images',
  UPLOAD_DOCUMENTS: 'Upload Documents',

  // Navigation Actions
  NAVIGATE: 'Navigate',
  CLICK: 'Click',
  SCROLL: 'Scroll',
  SEARCH: 'Search',
  FILTER: 'Filter',
  SORT: 'Sort',
  PAGINATE: 'Paginate',
  BACK_BUTTON: 'Back Button',
  MENU_OPEN: 'Menu Open',
  MENU_CLOSE: 'Menu Close',
  SIDEBAR_TOGGLE: 'Sidebar Toggle',

  // Authentication Actions
  OTP_SEND: 'OTP Send',
  OTP_VERIFY: 'OTP Verify',
  OTP_RESEND: 'OTP Resend',

  // Messaging Actions
  SEND_MESSAGE: 'Send Message',
  RECEIVE_MESSAGE: 'Receive Message',
  READ_MESSAGE: 'Read Message',

  // Search Actions
  RECOMENDATION_SEARCH_START: 'Recommendation_Search Start',
  RECOMENDATION_SEARCH_RESULT: 'Recommendation_Search Result',
  RECOMENDATION_SEARCH_SAVE: 'Recommendation_Search Save',

  // Filter Actions
  RECOMENDATION_FILTER_APPLY: 'Recommendation Filter Apply',
  RECOMENDATION_FILTER_CLEAR: 'Recommendation Filter Clear',

  // Organization Actions
  TEAM_ADD: 'Team Add',
  TEAM_REMOVE: 'Team Remove',
  TEAM_UPDATE: 'Team Update',
  ROLE_CHANGE: 'Role Change',
  PERMISSION_UPDATE: 'Permission Update',

  // Notification Actions
  NOTIFICATION_READ: 'Notification Read',
  NOTIFICATION_DELETE: 'Notification Delete',

  // Boost Actions
  BOOST_PURCHASE: 'Boost Purchase',
  BOOST_ACTIVATE: 'Boost Activate',
  BOOST_DEACTIVATE: 'Boost Deactivate',
  BOOST_UPGRADE: 'Boost Upgrade',
  BOOST_EXTEND: 'Boost Extend',

  // Materials Actions
  MATERIAL_GENERATE: 'Material Generate',
  MATERIAL_DOWNLOAD: 'Material Download',
  MATERIAL_SHARE: 'Material Share',
  MATERIAL_EDIT: 'Material Edit',
  FLYER_CREATE: 'Flyer Create',
  BROCHURE_CREATE: 'Brochure Create',
};

// Helper function to create custom events
export const createAnalyticsEvent = (
  category,
  action,
  label,
  value = null
) => ({
  category,
  action,
  label,
  value,
});
